import React from 'react';
import { Accordion, AccordionItem } from 'react-sanfona';

export default ({ data }) => {
    return (
        <Accordion className="accordion">
            {data.map(item => {
                const title = (
                    <div className={'accordion__title ' + item.className}>
                        {item.title}
                        <i className="accordion__arrow" />
                    </div>
                );
                return (
                    <AccordionItem
                        className="accordion__entry"
                        expandedClassName="is-active"
                        bodyClassName={
                            'accordion__content accordion__title-' + item.title
                        }
                        title={title}
                        slug={item.title}
                        key={item.title}
                    >
                        {item.content}
                    </AccordionItem>
                );
            })}
        </Accordion>
    );
};



// WEBPACK FOOTER //
// ./src/components/ui/accordion.js